import React, { useState } from "react";

const Photo = ({ src }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="md:w-1/3 px-3 w-full md:py-6 py-2 md:mt-2 mt-10">
      <img
        src={src}
        alt="Gallery"
        className="md:w-full h-auto cursor-pointer  rounded-lg shadow-lg"
        onClick={toggleExpand}
      />
      {expanded && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-75 flex justify-center items-center ease-in duration-300"
          onClick={toggleExpand}
        >
          <img
            src={src}
            alt="Expanded"
            className="max-w-full max-h-full  md:p-5 rounded-lg "
          />
        </div>
      )}
    </div>
  );
};

export default Photo;
